// extracted by mini-css-extract-plugin
export default {"typography":"Homepage_typography__7+GCG","row":"Homepage_row__TgUC9","title":"Homepage_title__3GBMm"};